import { Grid } from '@material-ui/core'
import React from 'react'
import FetchData from '../../../shared/fetchData'
import { checkValidity, updateObject } from '../../../shared/utility'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import Input from '../../UI/Input/Input'
import './LockerTypeForm.css'

const LockerTypeForm = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [id, setId] = React.useState('')
    const [lockerType, setLockerType] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        length: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'طول',
                unit: 'سانتیمتر'
            },
            validation: {
                required: true,
                justNumber: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        width: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'عرض',
                unit: 'سانتیمتر'
            },
            validation: {
                required: true,
                justNumber: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        height: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'ارتفاع',
                unit: 'سانتیمتر'
            },
            validation: {
                required: true,
                justNumber: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        weight: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'وزن',
                unit: 'گرم'
            },
            validation: {
                required: true,
                justNumber: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        if (props.edit == true) {
            const lckrTp = lockerType
            lckrTp.description.value = props.lockerType.description
            lckrTp.length.value = props.lockerType.length
            lckrTp.width.value = props.lockerType.width
            lckrTp.height.value = props.lockerType.height
            lckrTp.weight.value = props.lockerType.weight
            setLockerType(lckrTp)
            setEdit(true)
            setId(props.lockerType.id)
        }
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(lockerType, {
            [controlName]: updateObject(lockerType[controlName], {
                value: !checkValidity(event.target.value, lockerType[controlName].validation) ? lockerType[controlName].value : event.target.value,
                valid: checkValidity(event.target.value, lockerType[controlName].validation),
                errorMessage: !checkValidity(event.target.value, lockerType[controlName].validation) ? 'مقدار وارد شده صحیح نیست' : lockerType[controlName].errorMessage
            })
        });
        setLockerType(updatedControls)
    }

    const lockerTypeSubmit = (event) => {
        let valid = true
        const lt = lockerType
        for (let key in lt) {
            if (!checkValidity(lt[key].value, lt[key].validation)) {
                lt[key].valid = false
                valid = false
            }
        }
        if (!valid) {
            setLockerType(lt)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        } else {
            if (!edit) {
                setLoading(true)
                const lckrTp = lockerType
                var raw = JSON.stringify({
                    "lockerType": {
                        "description": lckrTp.description.value,
                        "length": lckrTp.length.value,
                        "width": lckrTp.width.value,
                        "height": lckrTp.height.value,
                        "weight": lckrTp.weight.value
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/lockertypes/insertLockerType'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.toggleNewLockerForm(false)
                        }
                    })
                    .catch(error => setLoading(false))
            } else {
                setLoading(true)
                const lckrTp = lockerType
                var raw = JSON.stringify({
                    "lockerType": {
                        "id": id,
                        "description": lckrTp.description.value,
                        "length": lckrTp.length.value,
                        "width": lckrTp.width.value,
                        "height": lckrTp.height.value,
                        "weight": lckrTp.weight.value
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/lockertypes/updateLockerType'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.toggleNewLockerForm(false)
                        }
                    })
                    .catch(error => setLoading(false))
            }
        }
    }

    const formElementsArray = [];
    for (let key in lockerType) {
        formElementsArray.push({
            id: key,
            config: lockerType[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="6 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    return (
        <div className='row justify-content-center'>
            <Grid lg={6} md={10} sm={11} xs={11}>
                <ContentForm headetText='نوع باکس'>
                    <div className='lckr-tp-frm'>
                        {form}
                    </div>
                    <div className='col-12'>
                        <div className='row justify-content-center w-100 mt-3'>
                            <div className='col-6 text-center'>
                                <Button btnType="General" clicked={(event) => props.toggleNewLockerForm(false)}>برگشت</Button>
                            </div>
                            <div className='col-6 text-center'>
                                <Button btnType="Success" clicked={lockerTypeSubmit}>ثبت</Button>
                            </div>
                        </div>
                    </div>
                </ContentForm>
            </Grid>
        </div>
    )
}

export default LockerTypeForm